import { render, staticRenderFns } from "./Errormsj.vue?vue&type=template&id=35f9af28&scoped=true&"
import script from "./Errormsj.vue?vue&type=script&lang=js&"
export * from "./Errormsj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9af28",
  null
  
)

export default component.exports